import { observer } from "mobx-react";
import { useHistory } from "react-router-dom";
import { Button, Snackbar } from "@material-ui/core";
import { MessageSnack } from "../Messages";
import Alert from "../Messages/Alert";
import { MessageStore, ProfileStore } from "store";
import { TabsProfile } from "store/ProfileStore";
import { lang } from "i18nLang";

export const SystemMessageSnack = observer(() => {
  const open = MessageStore.message !== "";

  const handleClose = (ev) => {
    MessageStore.clearMessage();
  };

  return (
    <MessageSnack
      autoHideDuration={MessageStore.autoHideDuration}
      open={open}
      onClose={handleClose}
      ContentProps={{
        "aria-describedby": "message-id",
      }}
      message={<span id="message-id">{MessageStore.message}</span>}
      type={MessageStore.status}
    />
  );
});

export const IntegrationMessageSnack = observer(() => {
  const history = useHistory();
  const open = MessageStore.getShowIntegration();

  const handleClose = (ev, reason) => {
    MessageStore.closeIntegrationMessage();
  };

  const handleRedirect = () => {
    history.push("/kanban");
    ProfileStore.openProfileLayer(TabsProfile.COMPANY);
  };

  const redirectButton = () => (
    <Button size="small" onClick={(ev) => handleRedirect()}>
      {lang("integrationSetup.configuration")}
    </Button>
  );

  return (
    <Snackbar
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      onClose={handleClose}
      autoHideDuration={6000}
      open={open}
    >
      <Alert icon={false} type={"error"} action={redirectButton()}>
        {lang("integrationSetup.error.missIntegration")}
      </Alert>
    </Snackbar>
  );
});
